// src/hr/portal/FormError.js -- a form's error block (the server's message, usually). It scrolls itself
// into view when it appears, so a refusal at the end of a long drawer is never off screen.
import React, { useEffect, useRef } from 'react';
import { FiAlertCircle } from 'react-icons/fi';
import { cx } from '../kit/util';

export function FormError({ children, className }) {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (children && el && typeof el.scrollIntoView === 'function') el.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
  }, [children]);
  if (!children) return null;
  return (
    <div ref={ref} className={cx('hrp-form-err', className)} role="alert">
      <FiAlertCircle aria-hidden="true" />
      <span>{children}</span>
    </div>
  );
}

export default FormError;
